import React, { useState } from "react";
import { GrLocation } from "react-icons/gr";
import Apply from "./applyFoam";
import moment from "moment";
import parse from "html-react-parser";
import JobDetailsModal from "./ViewDetails";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const JobListings = ({ jobs }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [titleStore, setTitleStore] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });

  return (
    <section className="py-12  bg-gradient-to-b from-gray-100 to-white"       id="target-section"
>
      <div className="max-w-[1280px] md:px-10 px-5 md:py-10 py-5 mx-auto text-center">
        <h2 className="text-2xl font-medium text-[#F8A133]">Open Positions</h2>
        <h2 className="small:text-2xl text-xl font-medium text-secondary">
          Explore exciting career opportunities
        </h2>
        <h3 className="small:text-2xl text-xl font-medium text-secondary mb-8">
          Find the role that matches your skills and passion.
        </h3>
        <div className="flex flex-wrap justify-center gap-6">
          {jobs.map((job, index) => (
            <JobCard
              key={index}
              job={job}
              setTitleStore={setTitleStore}
              openModal={() => setIsOpen(true)}
            />
          ))}
        </div>
      </div>
      <Apply isOpen={isOpen} setIsOpen={setIsOpen} titleStore={titleStore} />
    </section>
  );
};

const JobCard = ({ job, openModal, setTitleStore }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });
  const MAX_WORDS = 30; // Adjust as needed
const truncateText = (text) => {
  const words = text.split(" ");
  return words.length > MAX_WORDS ? words.slice(0, MAX_WORDS).join(" ") + "..." : text;
};

  return (
    <motion.div
      ref={ref}
      initial={{ rotateX: -90, opacity: 0 }}
      animate={inView ? { rotateX: 0, opacity: 1 } : {}}
      transition={{ duration: 1, ease: "easeOut" }}
      className="flex flex-col justify-between border border-gray-200 shadow-md rounded-lg p-6 w-full md:w-[30%] bg-white"
    >
      <div className="flex items-center gap-8" >
        <p className="text-xs font-bold bg-[#FFC400] bg-opacity-25 px-2 py-1 rounded">
          {moment(job.created_at).format("MMM DD, YYYY")}
        </p>
        <p className="h-[2px] bg-[#FFC400] flex-1 opacity-25"></p>
      </div>
      <h3 className="text-lg font-semibold mt-2">{job?.job_title}</h3>
      <p className="text-[#B0B0B0] text-sm flex items-center gap-1 mt-5">
        <GrLocation className="text-black font-bold text-2xl" /> {job?.location}
      </p>
      <div className="text-black text-sm mt-2  text-justify py-5" 
 >
  {parse(truncateText(job?.job_description || ""))}
  </div>

      <div className="mt-4 flex flex-col gap-2">
        <button
          className="w-full border border-[#06518B] text-[#06518B] py-2 rounded-lg font-semibold mb-5 hover:bg-[#06518B] hover:text-white transition duration-300"
          onClick={() => {
            setTitleStore(job?.job_title);
            openModal();
          }}
        >
          Apply Now
        </button>
        <button
          className="w-full text-black font-semibold"
          onClick={() => setIsModalOpen(true)}
        >
          View Details
        </button>
      </div>
      <JobDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        job={job}
      />
    </motion.div>
  );
};

export default JobListings;
